module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"prev":"Forrige","next":"Neste"},"en":{"prev":"Prev","next":"Next"}}')
  delete Component.options._Ctor
}
